// https://lincolnprofilev9.cms.dealer.com/2025-lincoln-aviator.htm
export default {
	events: {
		widgetUserEvent: [
			{
				logic: ({ eventData }) => {
					const { result, widgetName } = eventData;

					return (
						(result === 'Opens gallery modal' &&
							widgetName === 'ws-media-viewer') ||
						widgetName === 'links-list'
					);
				},
				payload: ({ eventData }) => {
					let btnValue;
					if (eventData.widgetId === 'content9') {
						btnValue = 'exterior';
					}
					if (eventData.widgetId === 'content11') {
						btnValue = 'interior';
					}
					if (eventData.result === 'Navigated to link destination') {
						btnValue = 'search inventory';
					}
					if (eventData.result === 'Opened link in dialog') {
						btnValue = 'schedule test drive';
					}
					return {
						directCall: 'global-onclick',
						payload: {
							onclick: {
								onclick: `vehicle:action:${btnValue}`,
								onclickLinkName:
									'{client}vehicle:content:action:lincoln aviator'
							},
							vehicle: {
								modelYear: '2025',
								nameplate: 'lincoln aviator'
							}
						}
					};
				}
			}
		]
	}
};
